<script>
  import { Dialog } from 'element-ui'
  export default {
    name:'ElDialog',
    extends:Dialog
  }
</script>
